// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-wrapper .tabular-view {
  height: calc(100vh - 150px);
}
.dashboard-wrapper .tabular-view .p-datatable > .p-datatable-wrapper {
  width: 100%;
  height: auto;
  min-height: 0 !important;
  flex: 0 1 auto !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/index.scss"],"names":[],"mappings":"AAGE;EACE,2BAAA;AAFJ;AAII;EACE,WAAA;EACA,YAAA;EACA,wBAAA;EACA,yBAAA;AAFN","sourcesContent":[".dashboard-wrapper {\n\n  // height: auto !important;\n  .tabular-view {\n    height: calc(100vh - 150px); // Adjust based on your header height\n\n    .p-datatable>.p-datatable-wrapper {\n      width: 100%;\n      height: auto;\n      min-height: 0 !important;\n      flex: 0 1 auto !important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
